import React, { createContext, useState } from 'react'

export type CaptionMode = 'live' | 'transcript'

export type CaptionsContextType = {
  captionSize: number;
  setCaptionSize: React.Dispatch<React.SetStateAction<number>>;
  captionMode: CaptionMode;
  setCaptionMode: React.Dispatch<React.SetStateAction<CaptionMode>>;
}

const DEFAULT_CAPTION_SIZE = 2

export const CaptionsContext = createContext<CaptionsContextType>({
  captionSize: DEFAULT_CAPTION_SIZE,
  setCaptionSize: (x: number) => x,
  captionMode: 'live',
  setCaptionMode: (m: CaptionMode) => m,
})

type Props = {
  children?: React.ReactNode
};

export const CaptionsContextProvider: React.FC<Props> = ({ children }) => {
  const [captionSize, setCaptionSize] = useState<number>(DEFAULT_CAPTION_SIZE)
  const [captionMode, setCaptionMode] = useState<CaptionMode>('live')

  return (
    <CaptionsContext.Provider value={{
      captionSize, setCaptionSize, captionMode, setCaptionMode,
    }}
    >
      {children}
    </CaptionsContext.Provider>
  )
}
